const itemTypes = {
  REPORT: 'report'
};

export { itemTypes };
